import React, { useEffect, useState, useRef } from "react";
import RequestConfig from "../../mini_components/RequestConfig";
import { Bounce, toast } from "react-toastify";
import OTPInputField from "../../ui/CustomOtpInput/OTPInputField";
import { useQueryClient } from "@tanstack/react-query";
import PaymentButton from "../../ui/PaymentButton";

function WithdrawAuth({ close }) {
  const queryClient = useQueryClient();

  const [withdrawLoading, setWithdrawLoading] = useState(false);

  const [isConstantCode, setIsConstantCode] = useState(() => {
    const saved = localStorage.getItem("isConstantCode");
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [code, setCode] = useState(() => {
    return localStorage.getItem("withdrawAuthCode") || "";
  });

  const prevIsConstantRef = useRef(isConstantCode);

  const handleSubmit = () => {
    setWithdrawLoading(true);
    const raw = isConstantCode
      ? JSON.stringify({ fixed_pass: code })
      : JSON.stringify({ otp: code });

    RequestConfig.post(`/withdraws/`, raw)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success("درخواست شما با موفقیت ثبت شد");
          localStorage.setItem("isConstantCode", "true");
          localStorage.setItem("withdrawAuthCode", "");
          queryClient.invalidateQueries({ queryKey: ["getMoneyTransferReqs"] });
          queryClient.invalidateQueries({ queryKey: ["getDestinationIbans"] });
          close();
        }
      })
      .catch((err) => {
        toast.error(`خطا: ${err.response?.data?.detail || "خطای نامشخص"}`, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          transition: Bounce,
        });
      })
      .finally(() => {
        setWithdrawLoading(false);
      });
  };

  const handleVerifyCode = (e) => {
    e.preventDefault();
    setCode(code);
  };

  const sendOtp = () => {
    RequestConfig.post(`/withdraws/requests/otp/send/`)
      .then((response) => {
        if (response.status === 200) {
          // Maybe show a toast or log if needed
        }
      })
      .catch((err) => {
        toast.error(`خطا: ${err.response?.data?.detail || "خطای نامشخص"}`, {
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          transition: Bounce,
        });
      });
  };

  // Only send OTP if user switches from constant to sms code mode
  useEffect(() => {
    const prev = prevIsConstantRef.current;

    if (prev && !isConstantCode) {
      sendOtp();
    }

    prevIsConstantRef.current = isConstantCode;
  }, [isConstantCode]);

  useEffect(() => {
    localStorage.setItem("isConstantCode", "true");
  }, [close]);

  return (
    <div className="max-w-[90vw] w-fit min-w-[360px] bg-white m-auto p-4 rounded-lg flex flex-col">
      <div className="tab-switcher-wrapper">
        <button
          onClick={() => {
            setIsConstantCode(true);
            localStorage.setItem("isConstantCode", "true");
            setCode("");
            localStorage.setItem("withdrawAuthCode", "");
          }}
          className={`p-2 w-full rounded-[6px] text-[12px] transition duration-1000 ease-out transform ${
            isConstantCode ? "bg-neutral-10 text-black" : "text-[#808080]"
          }`}
        >
          رمز عبور ثابت
        </button>
        <button
          onClick={() => {
            setIsConstantCode(false);
            localStorage.setItem("isConstantCode", "false");
            setCode("");
            localStorage.setItem("withdrawAuthCode", "");
          }}
          className={`p-2 w-full rounded-[6px] text-[12px] transition duration-1000 ease-out transform ${
            !isConstantCode ? "bg-neutral-10 text-black" : "text-[#808080]"
          }`}
        >
          رمز عبور پیامکی
        </button>
      </div>

      <form
        className="flex flex-col gap-4 items-start mt-4"
        onSubmit={handleVerifyCode}
      >
        {isConstantCode ? (
          <>
            <p className="text-[#8591A0] text-[14px] font-semibold">
              لطفا رمز ثابت خود را جهت انتقال وجه ارسال نمایید
            </p>
            <div className="w-full flex justify-center" dir="ltr">
              <input
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                  localStorage.setItem("withdrawAuthCode", e.target.value);
                }}
                className="bg-neutral-10 w-full p-2 border"
              />
            </div>
          </>
        ) : (
          <>
            <p className="text-[#8591A0] text-[14px] font-semibold">
              لطفا کد تایید ارسال شده را جهت انتقال وجه ارسال نمایید
            </p>
            <div className="w-full flex justify-center" dir="ltr">
              <OTPInputField
                value={code}
                handleChange={(val) => {
                  setCode(val);
                  localStorage.setItem("withdrawAuthCode", val);
                }}
                styleObject={{ backgroundColor: "#F0F0F0" }}
                numOfInputs={6}
              />
            </div>
          </>
        )}

        <PaymentButton
          text={"پرداخت"}
          onClick={handleSubmit}
          type={"submit"}
          isPending={withdrawLoading}
        />
      </form>
    </div>
  );
}

export default WithdrawAuth;
